export default "__VITE_ASSET__2bd46b0e__"